// extracted by mini-css-extract-plugin
export default {"container":"dlJv4l","left":"KqZBr1","right":"WeySpY"};